<template>
  <div class="wrapper">
    <ul class="info_list">
      <li>
        <span class="left_bq">就诊人</span>
        <span>{{ orderObj.patientname }}</span>
      </li>
      <li>
        <span class="left_bq">诊疗卡</span>
        <span>{{ orderObj.patcardno }}</span>
      </li>
      <li>
        <span class="left_bq">订单号</span>
        <span>{{ orderObj.lockid }}</span>
      </li>
      <li>
        <span class="left_bq">订单状态</span>
        <span>{{
          orderObj.stauts == 0 ? "未付款" : orderObj.stauts == 1 ? "已挂号" : orderObj.stauts == 2 ? "已就诊" : "已取消"
        }}</span>
      </li>
      <li>
        <span class="left_bq">就医时间</span>
        <span>{{ orderObj.visitingday }} {{ orderObj.visitingtime }}</span>
      </li>
      <!-- <li>
        <span class="left_bq">订单时间</span>
        <span>{{ orderObj.regtime }}</span>
      </li> -->
      <li>
        <span class="left_bq">院区</span>
        <span>{{ orderObj.deptname }}</span>
      </li>
      <li>
        <span class="left_bq">就诊科室</span>
        <span>{{ orderObj.parentdeptname }}</span>
      </li>
      <li>
        <span class="left_bq">医生姓名</span>
        <span>{{ orderObj.doctor }}</span>
      </li>
      <li>
        <span class="left_bq">诊金</span>
        <span style="color: #BE526A">{{ orderObj.fee }}元</span>
      </li>
    </ul>
    <div @click="goPCA" class="yygh" style="margin-top: 20px;">
      <van-button type="info">健康档案调阅授权</van-button>
    </div>
    <img id="barcode1" class="bar_code" />
    <vue-qr
      class="ewm"
      :text="orderObj.lockid"
      :logoScale="50"
      :size="100"
      :margin="0"
      :logoCornerRadius="0"
    ></vue-qr>
    <div @click="cancle" class="yygh" v-if="orderObj.isexpired == 0 && (orderObj.stauts == 0 || orderObj.stauts == 1)">
      <van-button type="info">取消订单</van-button>
    </div>
    <div @click="goback" class="yygh" v-show="show">
      <van-button type="info">返回列表</van-button>
    </div>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";
import { GetRequest } from "@/tool/parameter.js";
import { getRegRecordDetail, CancelLockRegOrder } from "@/request/api.js";
import VueQr from "vue-qr";
export default {
  components: {
    VueQr
  },
  data() {
    return {
      orderObj: {
        lockid: ""
      },
      show: false
    };
  },
  created() {},
  mounted() {
    this.getOrder();
  },
  methods: {
    async getOrder() {
      if (GetRequest("lockid") == undefined) {
        this.show = true;
        let orderUser = JSON.parse(sessionStorage.getItem("orderUser"));
        let orderDetails = JSON.parse(sessionStorage.getItem("orderDetails"));
        // console.log(JSON.parse(JSON.stringify(orderUser)),JSON.parse(JSON.stringify(orderDetails)));
        this.orderObj = {
          patientname: orderUser.patientname,
          patcardno: orderUser.patientId,
          lockid: orderDetails.orderId,
          stauts: orderDetails.isPay,
          visitingday: orderDetails.orderDate,
          deptname: orderDetails.hspCode == 31?"茂名市慢性病防治中心(计星院区)":(orderDetails.hspCode == 41 || orderDetails.hspCode == 42)?"茂名市慢性病防治中心(迎宾院区)":"茂名市慢性病防治中心(金塘院区)",
          parentdeptname: orderDetails.deptName,
          doctor: orderDetails.doctorName,
          fee: orderDetails.fee,
          isexpired: orderDetails.isexpired
        }
        // console.log(this.orderObj,orderUser)
        JsBarcode("#barcode1", this.orderObj.patcardno, {
          format: "CODE128", //条形码的格式
          width: 2, //线宽
          height: 40, //条码高度
          displayValue: true, //是否显示文字
          lineColor: "#000", //线条颜色
          margin: 10, //设置条形码周围的空白区域
          textAlign: "center", //文字所在位置,默认中间
          text: this.orderObj.patcardno, //条形码下面显示的文本内容
          fontSize: 14 //设置文本的大小
        });
      } else {
        this.show = false;
        let res = await getRegRecordDetail(GetRequest("lockid"));
        if (res.data.message == "操作成功") {
          this.orderObj = res.data.obj;
          JsBarcode("#barcode1", this.orderObj.patcardno, {
            format: "CODE128", //条形码的格式
            width: 2, //线宽
            height: 40, //条码高度
            displayValue: true, //是否显示文字
            lineColor: "#000", //线条颜色
            margin: 10, //设置条形码周围的空白区域
            textAlign: "center", //文字所在位置,默认中间
            text: this.orderObj.patcardno, //条形码下面显示的文本内容
            fontSize: 14 //设置文本的大小
          });
        }
      }
    },

    // 取消订单
    async cancle(){
      this.Dialog.confirm({
        title: '提示',
        message: '确定取消预约？',
        confirmButtonColor: "#ee0a24"
      })
        .then(async () => {
          let map = {
            lockID: this.orderObj.lockid,
            userId: "7148"
          }
          let res = await CancelLockRegOrder(map)
          if(res.data.message == '操作成功'){
            this.Toast.success("取消成功")
            setTimeout(() => {
              if(GetRequest("lockid") == undefined){
                this.$router.go(-1);
              } else {
                this.$router.go(0);
              }
            }, 600);
          }
        })
        .catch(() => {});
    },

    // 健康档案调阅授权
    goPCA(){
      this.$router.push(`/PHRAccessAuthorize?name=${this.orderObj.patientname}&cardno=${this.orderObj.patcardno}`);
    },

    // 返回列表
    goback(){
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  background: #f9f9f9;
  overflow: auto;
  .info_list {
    display: flex;
    flex-flow: column nowrap;
    background: white;
    > li {
      margin-left: 10px;
      padding: 8px 14px 8px 0px;
      font-size: 14px;
      border-bottom: 1px solid #ddd;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      .left_bq {
        color: #999;
        letter-spacing: 1px;
      }
    }
  }
  .bar_code {
    display: block;
    margin: 20px auto 0px;
  }
  .ewm {
    display: block !important;
    margin: 10px auto 20px;
  }
  /deep/ .yygh {
    // margin-top: 20px;
    width: 355px;
    text-align: center;
    margin: 0px 10px 10px;
    color: rgb(255, 255, 255);
    .van-button {
      background: #0E91FD;
      padding: 20px 0px;
      width: 355px;
      letter-spacing: 1px;
      font-size: 18px;
      border-color: #0E91FD;
      border-radius: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/RegRecordDetail.vue